// InvoicePage.tsx
import React, {FC, useEffect, useState, useCallback} from 'react'
import {Form, Formik, FormikProps} from 'formik'
import {ConfirmModal} from '../../../../shared/components/ConfirmModal'
import {
  DELIVERY_OPTIONS,
  ECURRENCY_OPTIONS,
  EINVOICE_OPTIONS,
  IInvoiceModel,
  initialInvoiceValues,
  invoiceSchema,
  KDVREASON_OPTIONS,
  PAYMENT_OPTIONS,
  TEVKIFATREASON_OPTIONS,
} from './InvoiceModel'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {showErrorToast, showSuccessToast} from '../../../../shared/components/ToastUtils'
import {createInvoice} from './Api'
import FormTabHeader, {TabOption} from '../../../../shared/components/FormTabHeader'
import TextInput from '../../../../shared/components/TextInput'
import SelectInput from '../../../../shared/components/SelectInput'
import AsyncSelectInput from '../../../../shared/components/AsyncSelectInput'
import PhoneInput from '../../../../shared/components/PhoneInput'
import {branches, fetchAsyncCustomerData} from '../../../../shared/models/SharedApiLookups'
import TextAreaInput from '../../../../shared/components/TextAreaInput'
import AsyncSearchInput from '../../../../shared/components/AsyncSearchInput'
import { AsyncCustomerModel } from '../../../../shared/models/ApiModels'
const InvoicePage: FC = () => {
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [invoices, setInvoices] = useState<IInvoiceModel[]>([])
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const [tab, setTab] = useState<string | 'form'>('form')
  const [currentPage, setCurrentPage] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [sortBy, setSortBy] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [error, setError] = useState<string | null>(null)
  const [customer, setCustomer] = useState<{value: string; label: string} | null>(null)
  const [customerName, setCustomerName] = useState<string>('')

  const [branchOptions, setBranchOptions] = useState<{value: string; label: string}[]>([])

  useEffect(() => {
    const fetchBranches = async () => {
      const data = await branches()
      setBranchOptions(data)
    }
    fetchBranches()
  }, [])

  const tabOptions: TabOption<'form'>[] = [
    {key: 'form', title: 'Satış Faturası', icon: 'bi bi-geo-alt'},
  ]

  const fetchInvoices = useCallback(
    async (page: number = 0, sort?: string, order?: 'asc' | 'desc') => {
      setLoading(true)
      setError(null)
    },
    []
  )

  // İlk yükleme
  useEffect(() => {
    if (tab === 'list') {
      fetchInvoices(0)
    }
  }, [tab, fetchInvoices])

  const handleSave = async (values: IInvoiceModel, resetForm: () => void) => {
    setLoading(true)
    try {
      if (selectedId) {
        await createInvoice(values)
        showSuccessToast('Fatura İşlemi başarıyla oluşturuldu')
      } else {
        await createInvoice(values)
        showSuccessToast('Fatura İşlemi başarıyla oluşturuldu')
      }
      setCurrentPage(0)
      resetForm()
      setSelectedId(null)
      setTab('form')
    } catch (err) {
      showErrorToast('Bir hata oluştu')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Formik
        initialValues={initialInvoiceValues}
        validationSchema={invoiceSchema}
        enableReinitialize
        onSubmit={(values, {resetForm}) => handleSave(values, resetForm)}
      >
        {(formik) => {
          const handleReset = () => {
            formik.resetForm()
            setSelectedId(null)
            setTab('form')
          }

          return (
            <>
              <FormTabHeader
                formId='invoiceForm'
                formikSubmit={formik.handleSubmit}
                formikReset={handleReset}
                loading={loading}
                tab={tab}
                setTab={setTab}
                setSelectedId={setSelectedId}
                tabs={tabOptions}
                onExportExcel={() => console.log('Excel export')}
              />
              <div className='card mb-5'>
                {/* Form  Tabları */}
                {tab === 'form' && (
                  <Form id='invoiceForm' className='form card-body'>
                    {tab === 'form' && (
                      <>
                        <div className='row mb-6'>
                          <div className='col-md-6'>
                            <label className='form-label'>Cari Ara</label>
                            <AsyncSearchInput<AsyncCustomerModel>
                              name="customerId"
                              label='Cari Ara'
                              placeholder='Ad Soyad girin...'
                              fetchHandler={fetchAsyncCustomerData}
                              displayField={(item) => `${item.firstName} ${item.lastName}`}
                              onSelect={(item) => console.log('Seçilen cari:', item)}
                              onClear={() => console.log('Cari temizlendi')}
                            />
                          </div>
                          <TextInput
                            name='invoiceDate'
                            label='Fatura Tarihi'
                            type='datetime-local'
                            wrapperClassName='col-md-6'
                          />
                        </div>

                        <div className='row mb-6'>
                          {/* Ad */}
                          {/* <div className='col-md-6'>
                            <label className='form-label'>Ad</label>
                            <input
                            type='text'
                            className='form-control'
                            placeholder='Ad'
                            value={formik.values.customerName ?? ''}
                            onChange={(e) => formik.setFieldValue('customerName', e.target.value)}
                            />
                        </div> */}

                          <TextInput name='customerName' label='Ad' wrapperClassName='col-md-6' />

                          {/* Vade Tarihi */}
                          <TextInput
                            name='dueDate'
                            label='Vade Tarihi'
                            type='date'
                            wrapperClassName='col-md-6'
                          />

                          {/* Telefon */}
                          <PhoneInput
                            name='phone'
                            type='phone'
                            label='Telefon'
                            wrapperClassName='col-md-6'
                          />

                          {/* Döviz Bilgileri */}
                          <div className='col-md-6'>
                            <div className='row'>
                              <div className='col-md-4'>
                                <TextInput name='exchangeEur' label='EUR' />
                              </div>
                              <div className='col-md-4'>
                                <TextInput name='exchangeUsd' label='USD' />
                              </div>
                              <div className='col-md-4'>
                                <TextInput name='exchangeGbp' label='GBP' />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <TextInput name='address' label='Adres' wrapperClassName='col-md-6' />
                          <TextInput
                            name='documentNo'
                            label='Evrak No'
                            wrapperClassName='col-md-6'
                          />
                        </div>
                        <div className='row mb-6'>
                          <TextInput name='district' label='İlçe' wrapperClassName='col-md-6' />
                          <TextInput
                            name='returnInvoiceNo'
                            label='İade Fatura No'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput name='city' label='Şehir' wrapperClassName='col-md-6' />
                          <TextInput
                            name='invoiceType'
                            label='Fatura Türü'
                            wrapperClassName='col-md-3'
                          />
                          <SelectInput
                            name='currency'
                            label='E-Döviz'
                            options={ECURRENCY_OPTIONS}
                            wrapperClassName='col-md-3'
                          />
                        </div>

                        <div className='row mb-6'>
                          <TextInput
                            name='taxOffice'
                            label='Vergi Dairesi'
                            wrapperClassName='col-md-6'
                          />
                          <SelectInput
                            name='paymentType'
                            label='Ödeme Türü'
                            options={PAYMENT_OPTIONS}
                            wrapperClassName='col-md-3'
                          />
                          <SelectInput
                            name='deliveryType'
                            label='Gönderim Türü'
                            options={DELIVERY_OPTIONS}
                            wrapperClassName='col-md-3'
                          />
                        </div>
                        <div className='row mb-6'>
                          <TextInput
                            name='taxNumber'
                            label='Vergi Numarası'
                            wrapperClassName='col-md-6'
                            addon={
                              <button
                                type='button'
                                className='btn btn-primary'
                                onClick={() =>
                                  console.log('Kontrol ediliyor:', formik.values.taxNumber)
                                }
                              >
                                Kontrol
                              </button>
                            }
                          />

                          <SelectInput
                            name='kdvExemptionReason'
                            label='KDV Muafiyet Sebebi'
                            options={KDVREASON_OPTIONS}
                            wrapperClassName='col-md-6'
                          />
                        </div>
                        <div className='row mb-6'>
                          <TextInput
                            name='email'
                            label='Mail Adresi'
                            type='email'
                            wrapperClassName='col-md-6'
                          />
                          <SelectInput
                            name='eInvoiceType'
                            label='E Fatura Tipi'
                            wrapperClassName='col-md-6'
                            options={EINVOICE_OPTIONS}
                          />
                        </div>
                        <div className='row mb-6'>
                          <SelectInput
                            name='branch'
                            label='Şube'
                            wrapperClassName='col-md-6'
                            options={branchOptions}
                          />
                          <TextInput
                            name='website'
                            label='İnternet Sitesi'
                            wrapperClassName='col-md-6'
                          />
                        </div>

                        <div className='row mb-6'>
                          <TextInput
                            name='subtotal'
                            label='Ara Toplam'
                            wrapperClassName='col-md-6'
                          />

                          <TextAreaInput
                            name='description'
                            label='Açıklama'
                            wrapperClassName='col-md-6'
                          />
                        </div>

                        <div className='row mb-6'>
                          <TextInput
                            name='discountTotal'
                            label='Toplam İndirim'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput name='amount' label='Tutar' wrapperClassName='col-md-6' />
                        </div>

                        <div className='row mb-6'>
                          <TextInput name='kdv' label='KDV' wrapperClassName='col-md-6' />

                          <TextInput name='otv' label='ÖTV' wrapperClassName='col-md-6' />
                        </div>

                        <div className='row mb-6'>
                          <TextInput
                            name='generalTotal'
                            label='Genel Toplam'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='foreignTotal'
                            label='Döviz Toplam'
                            wrapperClassName='col-md-6'
                          />
                        </div>

                        <div className='row mb-6'>
                          <TextInput name='tevkifat' label='TEVKIFAT' wrapperClassName='col-md-6' />
                          <SelectInput
                            name='tevkifatReason'
                            label='Tevkifat Sebebi'
                            wrapperClassName='col-md-6'
                            options={TEVKIFATREASON_OPTIONS}
                          />
                        </div>

                        <div className='row mb-6'>
                          <TextInput
                            name='eInvoiceTemplate'
                            label='e Fatura Şablonu'
                            wrapperClassName='col-md-6'
                          />
                          <TextInput
                            name='invoiceIssuer'
                            label='Onaylayan'
                            wrapperClassName='col-md-6'
                          />
                        </div>

                        <div className='row mb-3'>
                          <TextInput
                            name='invoiceIdText'
                            label='Fatura Kimliği Metni'
                            wrapperClassName='col-md-6'
                          />
                        </div>
                      </>
                    )}
                  </Form>
                )}
              </div>
            </>
          )
        }}
      </Formik>

      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export {InvoicePage}
